module.exports = __webpack_public_path__ + "static/media/calendar-week.a9dc5187.svg";